import { connect } from 'react-redux';
import Banners from './Banners';
import 'index.scss';

const mapStateToProps = (state) => {
  const {
    templateVariables: {
      alert_banners: {
        messages: allMessages = [],
        totalLength,
      } = {},
    } = {},
  } = state;

  const banners = allMessages;
  if (0 < totalLength) {
    return {
      banners,
      totalLength,
    };
  }
  return null;
};

export default connect(mapStateToProps)(Banners);
